"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@unform/core");
var AppContext_1 = __importDefault(require("../../AppProvider/AppContext"));
var Select_style_1 = __importDefault(require("./Select.style"));
var SelectPure_1 = require("./SelectPure");
exports.Select = function (_a) {
    var children = _a.children, name = _a.name, title = _a.title, items = _a.items, theme = _a.theme, _b = _a.as, as = _b === void 0 ? SelectPure_1.SelectPure : _b, rest = __rest(_a, ["children", "name", "title", "items", "theme", "as"]);
    var _c = react_1.useContext(AppContext_1.default).pureComponents, _d = (_c === void 0 ? {} : _c).Select, SelectComponent = _d === void 0 ? null : _d;
    var Component = SelectComponent !== null && SelectComponent !== void 0 ? SelectComponent : as;
    var inputRef = react_1.useRef(null);
    var _e = core_1.useField(name), fieldName = _e.fieldName, registerField = _e.registerField, defaultValue = _e.defaultValue, error = _e.error;
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField, children]);
    return (react_1.default.createElement(Select_style_1.default, { themeInput: theme },
        react_1.default.createElement(Component, __assign({ inputRef: inputRef, title: title, defaultValue: defaultValue, error: error, items: items }, rest), children)));
};
//# sourceMappingURL=Select.js.map